import { render, staticRenderFns } from "./ProtocolCard.vue?vue&type=template&id=737b89a4&scoped=true&"
import script from "./ProtocolCard.vue?vue&type=script&lang=js&"
export * from "./ProtocolCard.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolCard.vue?vue&type=style&index=0&id=737b89a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737b89a4",
  null
  
)

export default component.exports